import utils from 'utils';

import {useEffect, useRef, useState} from 'react';

import {UiCheckbox, UiTextInput, UiButton, DetailNote} from '@components/export';
import {useLabel} from '@/hooks/export';

import {InputAdornment} from '@mui/material';

export const DetailLinesProductItem = (props: {
    line: apiProductLine,
    locked: boolean,

    onLineUpdate: (field: string, value: any) => void,
    onOrderClick: (id: string) => void,
}) => {
    const label = useLabel();

    // fixme: duplicate from DetailLinesOrderItem
    // fixme: please, refactor it

    const timeoutRef = useRef(null);

    const [price, setPrice] = useState(props.line.price.toString().replace('.', ','));
    const priceRef = useRef(props.line.price.toString().replace('.', ','));

    const handle = {
        delayPriceUpdate(value: string) {
            if (!value.match('^([0-9,.]+)$')) {
                return;
            }

            priceRef.current = parseFloat(value.replace(',', '.')).toFixed(2);
            setPrice(value);

            if (!value || !value.match('^([0-9]+)(,?)([0-9]{0,2})$')) {
                return;
            }

            utils.doWithTimeout(() => {
                setPrice(priceRef.current);
                props.onLineUpdate('price', priceRef.current);
            }, 5000, timeoutRef);
        },
        doPriceUpdate() {
            props.onLineUpdate('price', parseFloat(priceRef.current.replace(',', '.')).toFixed(2));
        },
    };

    useEffect(() => {
        priceRef.current = parseFloat(props.line.price.toString()).toFixed(2).replace('.', ',');
        setPrice(parseFloat(props.line.price.toString()).toFixed(2).replace('.', ','));
    }, [props.line.price]);

    return <div className={classMap.item}>
        <div className={classMap.itemCell}>
            <span
                className={classMap.link}
            >
                <UiButton
                    style={2}
                    text={props.line.orderNum}
                    onClick={() => props.onOrderClick(props.line.orderId)}
                />
            </span>
        </div>
        <div className={classMap.itemCell}>
            <div>{props.line.accountName}</div>
            {
                props.line.note ?
                    <div className={classMap.itemCellNote}>
                        <span><i className={'iconfa-note'}></i>:</span>
                        <span>{props.line.note}</span>
                    </div> : <></>
            }
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            {props.line.qty + ' ' + label.qty}
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            <UiTextInput
                value={price}
                endAdornment={<InputAdornment position="end">{label.currency}</InputAdornment>}
                sx={{
                    padding: 0.5,
                    width: 120,
                    alignItems: 'baseline',
                    input: {textAlign: 'right', padding: 0, fontWeight: 500},
                }}
                onFocus={(e) => e.target.select()}
                onChange={(e) => handle.delayPriceUpdate(e.target.value || '0')}
                onBlur={() => {
                    clearTimeout(timeoutRef.current);
                    handle.doPriceUpdate();
                }}
                disabled={props.locked}
                size={'small'}
            />
        </div>
        <div className={classMap.itemCell + ' ' + classMap.itemCellRight}>
            {(props.line.price * props.line.qty).toFixed(2).replace('.', ',') + ' ' + label.currency}
        </div>
        <div className={classMap.itemCell + (props.locked ? ' ' + classMap.itemCellDisabled : '')}>
            <DetailNote
                note={props.line.note}
                onUpdate={(value) => props.onLineUpdate('note', value)}
                hideLabel
                disabled={props.locked}
                popupOrigin={{
                    anchorOrigin: {
                        vertical: 'top',
                        horizontal: -5,
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                }}
            />
            <div className={
                classMap.itemCellCheckbox +
                (props.line.isDone ? ' ' + classMap.itemCellCheckboxActive : '') +
                (props.locked ? ' ' + classMap.itemCellCheckboxDisabled : '')
            }>
                <UiCheckbox
                    onChange={(checked) => props.onLineUpdate('isDone', checked)}
                    checked={props.line.isDone}
                    disabled={props.locked}
                />
            </div>
        </div>
    </div>;
};

const cmpClass = 'detail-lines';
const classMap = utils.generateClassMap(cmpClass, {
    item: 'item',
    itemCell: 'item-cell',
    itemCellCheckbox: 'item-cell-checkbox',
    itemCellCheckboxActive: 'item-cell-checkbox--active',
    itemCellCheckboxDisabled: 'item-cell-checkbox--disabled',
    itemCellDisabled: 'item-cell--disabled',
    itemCellRight: 'item-cell--right',
    itemCellNote: 'item-cell-note',
    link: 'link',
});
